import req from "@/api/config/config";

//签名证书;
var signCert = {};
//加密证书;
var encCert = {};
//服务器证书
var serverCertBase64 = "";
// var serverCertBase64 =
//   "MIIC7jCCApGgAwIBAgIUIpRxWVN1Y9/yzOPrwlZSLDqlx8EwDAYIKoEcz1UBg3UFADBSMQswCQYDVQQGEwJDTjEcMBoGA1UEChMTaVRydXNDaGluYSBDby4sTHRkLjElMCMGA1UEAxMcaVRydXMgU00yIEVudGVycHJpc2UgQ0EgdGVzdDAeFw0yMzA0MjcwODQzMTFaFw0yNDA0MjYwODQzMTFaMCYxJDAiBgNVBAMMG+acjeWKoeerr+a1i+ivleWKoOWvhuivgeS5pjBZMBMGByqGSM49AgEGCCqBHM9VAYItA0IABIC0PPcTIvnKdSpZDoBfoRT1QNNqPKiC9SU7JQPJ95ATC1fIc1bikYUbgNmk5Zm09sZKF/GpzU7v77tN80ibbi6jggFtMIIBaTAJBgNVHRMEAjAAMAsGA1UdDwQEAwIF4DBrBgNVHS4EZDBiMGCgXqBchlpodHRwOi8vdG9wY2EtZGVtby5pdHJ1cy5jb20uY24vcHVibGljL2l0cnVzY3JsP0NBPTExMjAzMDRGMDhBRTlGOEJGOTk5MkFEQzVBM0E2REYyMUE2MDk2RDAwgaEGA1UdHwSBmTCBljCBk6CBkKCBjYaBimh0dHA6Ly90b3BjYS1kZW1vLml0cnVzLmNvbS5jbi9wdWJsaWMvaXRydXNjcmw/Q0E9MTEyMDMwNEYwOEFFOUY4QkY5OTkyQURDNUEzQTZERjIxQTYwOTZEMCZzZz1IQUNDMUIxQTA4QjQzMDJDRjg0QjA0QkE1QTA4RTg2OUE3OTFCQzc1M0IxRDAfBgNVHSMEGDAWgBQBJ4CrGLNopzA4yz4tu3AnLQapTzAdBgNVHQ4EFgQUy5LOa+dFO25Q+8WMx+34VhzBRHswDAYIKoEcz1UBg3UFAANJADBGAiEA/6UgE89v1JdR14gwVbNjsgZUBmMrmMpAVSMFtloymh0CIQDhM1a5+9jnGFLlb32VNsmoNlC4j3kJ4m6tUApFDn+Mgg==";

var url = req.systemIp;

//页面初始化
// $(document).ready(function() {
//   topEsaInit("both");
// });

//TopESA初始化，在页面中只能初始化一次,type按需传参
//type=sign表示当前页面只做签名
//type=enc表示当前页面只做加密
//type=both表示当前页面同时要做签名和加密
export function topEsaInit(type) {
  $(function() {
    // 服务器证书
    $.ajax({
      type: "GET",
      async: false,
      url: url + "/pc/ext/getKeyStoreCertList",
      success: function(res) {
        serverCertBase64 = JSON.parse(res)[0].base64;
      },
    });
  });

  // 配置项config.license
  $.ajax({
    type: "GET",
    async: false,
    url: url + "/pc/ext/getClient_license",
    success: function(res) {
      var config = {
        license: JSON.parse(res).msg,
        certDateFmtMode: true,
        disableExeUrl: true,
        installMode: true,
        genKeySpec: 2,
      };

      // 初始化
      TCA.config(config);
    },
  });

  // var config = {}

  // config.license =
  //   "dEwBCgAAAAEyMDIzMDQyNDAwMDAwMDIwNDMwNDI0MDAwMDAwMEQCIEBbOxCeM/fBaRSqHtNJD9V9l6DeqWq4BOTrKIC3R//rAiBepHWQquDnmm7INfy6fNMhKYCr0EeSJoJHp0FcooPJuAFDOyVF9BmGKc/RHphk7TqSbRs91QaOenu6xPRWX4frUg==";
  // config.certDateFmtMode = true;
  // config.disableExeUrl = true;
  // config.installMode = true;
  // config.genKeySpec = 2;

  // // 初始化
  // TCA.config(config);

  //读取Ukey中的证书
  if (type == "sign") {
    getSignCert();
  } else if (type == "enc") {
    getEncCert();
  } else if (type == "both") {
    getSignCert();
    getEncCert();
  } else {
    console.log("数字证书初始化失败");
    // alert("数字证书初始化失败");
  }
}

//消息P7签名-Ukey（不包含原文）
export function signP7() {
  //待签名的原文
  var plain = {
    SUPPLIERCODE: "P00021330",
    rfqcode: "DEC8000Z202306496",
    BZ: "6a4b352a-f5c7-56c6-dfa8-ed501a87d98e",
    ISTECDEVIATION: "0",
    ISBUSDEVIATION: "0",
    ESCRFQPURTENDER_CONTACT: "刘超",
    ESCRFQPURTENDER_CONTACTTEL: "18782965195",
    CONTACTEMAIL: "",
    FL: [
      1,
      9999,
      11298.87,
      null,
      null,
      "2024-06-20",
      13,
      9999,
      11298.87,
      1,
      9999,
      11298.87,
      null,
      null,
      "2024-06-20",
      13,
      9999,
      11298.87,
      1,
      9999,
      11298.87,
      null,
      null,
      "2024-06-20",
      13,
      9999,
      11298.87,
    ],
  };

  signCert.signMessage(
    JSON.stringify(plain),
    false,
    undefined,
    undefined,
    function(resultStatus, signData) {
      if (!checkResult(resultStatus)) {
        return;
      }

      //signData=签名值
      console.log("消息P7签名-签名值：" + signData);

      //以下编写业务代码......
    }
  );
}

//获取签名证书信息-Ukey
export function getSignCertInfo() {
  console.log("signCert", signCert);
  if (Object.keys(signCert).length == 0) {
    return false;
  }
  //证书使用者信息
  var DN = signCert.subject();

  //企业名称
  var CN = getOptionFromDN(DN, "CN=");
  console.log("企业名称：" + CN);

  //统一社会信用代码
  var SN = getOptionFromDN(DN, "SN=");
  console.log("统一社会信用代码：" + SN);

  //证书序列号
  var serialNumber = signCert.serialNumber();
  console.log("证书序列号：" + serialNumber);

  //以下编写业务代码......
  return serialNumber;
}

export async function  encFileBefore() {
  await CryptoUtil.showOpenDialog(
    "选择待加密文件",
  [{ typeTxt: "Pdf(*.txt)", typeExt: "*.pdf" }],function(res){
      console.log("result", res);
      if (res.retCode != 0) {
        alert("选择文件失败，或点击了取消");
        return ;
      }else{
        const pdfUrl=res.result
        const urlArry= pdfUrl.split('.')
        if(urlArry[urlArry.length-1]=='pdf'){
          const callbackUrl = `https://localhost:5832/viewerjs/web/pdfviewer.html?saveType=local&fileUrl=${pdfUrl}&savePath=${urlArry[0]}_已签章.${urlArry[urlArry.length-1]}`
          window.open(callbackUrl)
        }
        return
      }
  })
}

//文件加密file, path
export function encFile(project) {
  CryptoUtil.showOpenDialog(
    "选择待加密文件",
    [{ typeTxt: "Pdf(*.txt)", typeExt: "*.pdf" }],
    function(result) {
      console.log("result", result);
      if (result.retCode != 0) {
        alert("选择文件失败，或点击了取消");
        return;
      }

      console.log("文件加密-加密前的源文件：", result);
      //加密前的源文件路径
      var srcPath = result.result;
      console.log("文件加密-加密前的源文件路径：" + srcPath);
      if (srcPath.indexOf("_已加密") != -1) {
        alert("该文件已加密");
        return;
      }

      //加密后的加密文件路径
      var dstPath =
        srcPath.substring(0, srcPath.indexOf(".pdf")) + "_已加密.pdf";
      console.log("文件加密-加密后的加密文件路径：" + dstPath);

      //生成对称密钥
      CryptoUtil.random(16, function(resultStatus, symmKey) {
        if (!checkResult(resultStatus)) {
          return;
        }
        //生成IV
        CryptoUtil.random(16, function(resultStatus, symmIV) {
          if (!checkResult(resultStatus)) {
            return;
          }
          //对称加密文件TCA.SM4
          CryptoUtil.symmEncFile(
            symmKey,
            symmIV,
            TCA.SM4,
            srcPath,
            dstPath,
            function(resultStatus) {
              if (!checkResult(resultStatus)) {
                return;
              }

              if (Object.keys(signCert).length == 0) {
                alert("未安装数字证书，或未找到符合License的数字证书");
                return;
              }

              //文件P7签名（不包含原文）
              signCert.signFile(srcPath, false, undefined, undefined, function(
                resultStatus,
                signData
              ) {
                if (!checkResult(resultStatus)) {
                  return;
                }

                //signData=文件的签名值
                console.log("文件加密-文件的签名值：" + signData);

                //对称密钥
                var strKey = symmKey + "-" + symmIV;

                //创建服务器证书对象
                Certificate.parseCert(serverCertBase64, function(
                  result,
                  serverCert
                ) {
                  //serverCert=服务器证书
                  console.log("文件加密-服务器证书：" + serverCert.subject());

                  //服务器证书加密对称密钥
                  serverCert.encryptMessageRaw(strKey, function(
                    resultStatus,
                    encKey
                  ) {
                    if (!checkResult(resultStatus)) {
                      return;
                    }

                    //encKey=加密后的对称密钥
                    console.log("文件加密-加密后的对称密钥：" + encKey);

                    // 根据项目id 存入缓存
                    console.log('project',project);
                    var fileStore = [];
                    var flag = false;

                    var file = {
                      dstPath: dstPath,
                      fileName:
                        srcPath.indexOf("_已加密") != -1
                          ? srcPath.substring(
                              srcPath.lastIndexOf("\\") + 1,
                              srcPath.indexOf("_已加密")
                            )
                          : srcPath.substring(
                              srcPath.lastIndexOf("\\") + 1,
                              srcPath.indexOf(".pdf")
                            ),
                      encKey: encKey,
                      dstName: dstPath.substring(dstPath.lastIndexOf("\\") + 1),
                      filePath: srcPath.substring(0, srcPath.lastIndexOf("\\")),
                    };

                    if (JSON.parse(localStorage.getItem(`file_${project}`))) {
                      fileStore = JSON.parse(
                        localStorage.getItem(`file_${project}`)
                      );
                    }

                    fileStore.forEach((element, index) => {
                      if (
                        `${element.filePath}${element.fileName}` ==
                        `${file.filePath}${file.fileName}`
                      ) {
                        fileStore.splice(index, 1);
                        flag = true;
                      }
                    });
                    // if (!flag) {
                      fileStore.push(file);
                      localStorage.setItem(
                        `file_${project}`,
                        JSON.stringify(fileStore)
                      );
                      console.log(
                        "fileStore",
                        fileStore,
                        JSON.parse(localStorage.getItem(`file_${project}`))
                      );
                    // }
                  });
                });
              });
            }
          );
        });
      });
    }
  );
}

//获取签名证书
export function getSignCert() {
  CertStore.listAllCerts(function(resultStatus, certs) {
    if (!checkResult(resultStatus)) {
      return;
    }

    certs = certs.forSign();

    if (certs.size() == 0) {
      // alert("未安装数字证书，或未找到符合License的数字证书");
      signCert = {};
      console.log("未安装数字证书，或未找到符合License的数字证书");
      return;
    } else {
      for (var i = 0; i < certs.size(); i++) {
        var DN = certs.get(i).subject();
        if (DN.indexOf("OU=iTrusChina") > -1) {
          signCert = certs.get(i);
          break;
        }
        // alert("未安装数字证书，或未找到符合License的数字证书");
        console.log("未安装数字证书，或未找到符合License的数字证书");
        signCert = {};
      }
    }
  });
}

//获取加密证书
export function getEncCert() {
  CertStore.listAllCerts(function(resultStatus, certs) {
    if (!checkResult(resultStatus)) {
      return;
    }

    certs = certs.forEncrypt();

    if (certs.size() == 0) {
      signCert = {};
      // alert("未安装数字证书，或未找到符合License的数字证书");
      console.log("未安装数字证书，或未找到符合License的数字证书");
      return;
    } else {
      for (var i = 0; i < certs.size(); i++) {
        var DN = certs.get(i).subject();
        if (DN.indexOf("OU=iTrusChina") > -1) {
          encCert = certs.get(i);
          console.log(encCert);
          break;
        }
        // alert("未安装数字证书，或未找到符合License的数字证书");
        console.log("未安装数字证书，或未找到符合License的数字证书");
        signCert = {};
      }
    }
  });
}

//检查操作返回信息
export function checkResult(resultStatus) {
  if (resultStatus.retCode != 0) {
    console.log(resultStatus);
    // alert(
    //   "错误码：" + resultStatus.retCode + "\r\n错误信息：" + resultStatus.retMsg
    // );
    return false;
  }
  return true;
}

//从DN中获取主题项
export function getOptionFromDN(DN, option) {
  var t = DN.match(/(S(?!N)|L|O(?!U)|OU|SN|CN|E)=([^=]+)(?=, |$)/g);
  for (var i = 0; i < t.length; i++) {
    if (t[i].indexOf(option) === 0)
      return t[i].substr(option.length, t[i].length);
  }
  return null;
}

function verifyFileRaw(){

  pkcs7.parsePkcs7(b64OrP7Info, function(resultStatus, pkcs7){
    if(resultStatus.retCode!=0){
        alert("错误码：" + resultStatus.retCode + ", 错误消息：" + resultStatus.retMsg);
        return;
    }
    alert(pkcs7) // pkcs7
})
  
}

// $(document).click(function() {
//   topEsaInit("both");
// });
